<template>
  <div>
    <div class="video_channel">
      <div class="vc_concent">
        <div class="vc_item" v-for="item in channelList" :key="item.at_id">
          <a
            :href="
              item.at_name == '推荐'
                ? '/marvel-list?id=' + item.at_id
                : '/list-page?id=' + item.at_id
            "
            target="_blank"
          >
            {{ item.at_name }}
          </a>
        </div>
      </div>
    </div>
    <div class="video_details">
      <div v-show="playerOptions.sources[0].src" class="v_player">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player>
      </div>
      <!--      <div class="video_album" v-show="isAlbumDisplay">-->
      <!--        <div class="album_bar">-->
      <!--          <span class="album_item">选集</span>-->
      <!--          <span class="cancel" @click="disPlayAlbum">取消</span>-->
      <!--        </div>-->
      <!--        <ul class="album_num">-->
      <!--          <li v-for="item in albumList" :key="item.column" :class="item.column==currentNum?'active':''"-->
      <!--              @click="changeAlum(item.column)">-->
      <!--            &lt;!&ndash;            <a :href="'/play-page?classify=3&id='+item">{{ index + 1 }}</a>&ndash;&gt;-->
      <!--            <p class="item_idx">{{ item.column }}</p>-->
      <!--          </li>-->
      <!--        </ul>-->
      <!--      </div>-->

      <div class="vd_right">
        <!--        <div v-if="!isAlbum" class="vd_header">-->
        <!--          <div class="vdh_author">-->
        <!--            <img :src="image"/>-->
        <!--          </div>-->
        <!--          <div class="vdh_title">-->
        <!--            <p>-->
        <!--              {{ name }}-->
        <!--            </p>-->
        <!--            <el-button type="text" @click="dialogVisible = true">关注</el-button>-->
        <!--            &lt;!&ndash;            <button>关注</button>&ndash;&gt;-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="vd_title">
          <p>
            {{ title }}
            <!--            <button v-if="isOriginal">原创</button>-->
          </p>
        </div>
        <div class="vd_text">{{ description }}</div>
        <!--        <div class="vd_play_comments">-->
        <!--          <div class="vdc_play">{{ hitCount }}次播放</div>-->
        <!--          <div class="vdc_comments">{{ reviewCount ? reviewCount : 0 }}条评论</div>-->
        <!--        </div>-->
        <!--        <div class="vd_release">发布于{{ publishDate }}</div>-->
        <div class="vd_copyright">版权归原作者所有，如有侵权，请联系我们</div>
        <div class="share_info">
          <div class="share_sub">分享到：</div>
          <div
            class="social-share"
            data-sites="wechat, weibo, qq, qzone, douban"
          ></div>
        </div>
      </div>
      <!--      <div class="recommend">-->
      <!--        <div class="title">相关推荐</div>-->
      <!--        <ul class="content">-->
      <!--          <li v-for="item in recommendList" :key="item.id">-->
      <!--            <a :href="'/play-page?id=' + item.id">-->
      <!--              <div class="cul_img">-->
      <!--                <img :src="item.img_url" alt=""/>-->
      <!--                <div class="time">-->
      <!--                  <span class="v_pub">{{-->
      <!--                      item.publish_date ? item.publish_date.substr(5, 5) : ''-->
      <!--                    }}</span>-->
      <!--                  <span class="v_dur"> {{ item.video_duration }}</span>-->

      <!--                  &lt;!&ndash;                <div class="fr">{{item.video_duration}}</div>&ndash;&gt;-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <div class="cul_title1">-->
      <!--                {{ item.title }}-->
      <!--              </div>-->
      <!--              <div v-show="item.article_source" class="cul_title2">{{ item.article_source }}</div>-->
      <!--            </a>-->
      <!--          </li>-->
      <!--        </ul>-->
      <!--      </div>-->
      <!--      <div class="vd_cmt">-->
      <!--        <div class="comment">-->
      <!--          <div v-if="commentList.length>0" class="title">评论</div>-->
      <!--          <li class="item" v-for="item in commentList" :key="item.id">-->
      <!--            <div class="item_label">-->
      <!--              <div class="portrait">-->
      <!--                <div class="p_img">-->
      <!--                  <img :src="item.member.avatar" alt=""/>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <div class="commentator">{{ item.member.nickname }}</div>-->
      <!--              <div class="grade">-->
      <!--                {{ item.member.from_grade ? item.member.from_grade : "游客" }}-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div class="item_text">{{ item.content }}</div>-->
      <!--            <div class="item_date">{{ item.push_time }}</div>-->
      <!--          </li>-->
      <!--        </div>-->
      <!--        <div class="act_footer">-->
      <!--          请-->
      <!--          &lt;!&ndash;          <button class="btn" data-toggle="modal" data-target="#myModal">&ndash;&gt;-->
      <!--          &lt;!&ndash;            打开&ndash;&gt;-->
      <!--          &lt;!&ndash;          </button>&ndash;&gt;-->
      <!--          <el-button type="text" @click="dialogVisible = true">打开</el-button>-->
      <!--          科普中国APP发表评论或查看更多评论-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <!--    <download-dialog :visible.sync=dialogVisible></download-dialog>-->
  </div>
</template>
<script>
// import downloadDialog from "./component/DownloadDialog.vue";
import { getChannelList } from "@/api";
// import videojs from "video.js";

export default {
  // components: {downloadDialog},
  data() {
    return {
      // dialogVisible: false,
      // isAlbumDisplay: true,
      channelList: [],
      // isAlbum: false,
      // currentNum: "1",
      // isOriginal: false,
      title: "",
      description: "",
      // albumList: [],
      playerOptions: {
        playbackRates: [0.5, 1, 1.5, 2],
        autoplay: true,
        poster: "",
        // fluid: true,
        sources: [
          {
            type: "video/mp4",
            src: "",
          },
        ],
        height: 510,
        controlBar: {
          children: [
            "playToggle",
            "volumePanel",
            "currentTimeDisplay",
            "progressControl",
            "timeDivider",
            "durationDisplay",
            "fullscreenToggle",
            // "customButton",
            "playbackRateMenuButton",
            "pictureInPictureToggle",
          ],
        },
      },
      config: {
        sites: ["wechat", "weibo", "qq", "qzone", "douban"],
      },
    };
  },
  methods: {
    disPlayAlbum: function () {
      this.isAlbumDisplay = !this.isAlbumDisplay;
    },

    async initPlayPage() {
      let id = this.$route.query.id;
      this.playerOptions.sources[0].src = mock[id - 1].src;
      // this.playerOptions.sources.poster = mock[id].list[currentIdx].image;
      this.title = mock[id - 1].title;
      this.description = mock[id - 1].introduction;
    },

    async initChannelList() {
      try {
        let { data } = await getChannelList();
        this.channelList = data;
      } catch (e) {
        console.log(e);
      }
    },

    // initAlbumButton() {
    //   var VjsButton = videojs.getComponent("button");
    //   var customButton = videojs.extend(VjsButton, {
    //     constructor: function (player, options) {
    //       VjsButton.call(this, player, options);
    //       this.controlText("视频选集");
    //     },
    //     handleClick: () => {
    //       this.isAlbumDisplay = !this.isAlbumDisplay;
    //     },
    //     buildCSSClass: function () {
    //       return "vjs-album-control";
    //     },
    //   });
    //   videojs.registerComponent("customButton", customButton);
    // },

    // changeAlum(albumIdx) {
    //   this.currentNum = albumIdx;
    //   let id = this.$route.query.id - 1;
    //   this.playerOptions.sources[0].src = mock[id].list[albumIdx - 1].url;
    //   // this.playerOptions.sources.poster = mock[id].list[currentIdx].image;
    //   this.title = mock[id].list[albumIdx - 1].title;
    //   this.description = mock[id].desc;
    // }

    // jumpDetailPage(id) {
    //   this.$router.push({name: "PlayPage", query: {id: id}});
    // },
  },
  created() {
    this.initPlayPage();
    this.initChannelList();
    // this.getCommentList();
  },
  mounted() {
    // eslint-disable-next-line no-undef
    socialShare(".social-share, .share-component");
  },
};
const mock = [
  {
    id: 1,
    title: "森林防火常识",
    src: "http://vskd.bj.bcebos.com//video/2021/7/22/20217221626936841444_85_1228.mp4",
    classification: "应急避险",
    fabulous: 1,
    source: "应急管理部",
    date: "2021-07-22 15:36:53",
    introduction: "",
    duration: "01:44",
  },
  {
    id: 2,
    title: "警示片《家庭火灾防范事故》",
    src: "http://vskd.bj.bcebos.com//video/2021/7/22/20217221626936866978_85_1497.mp4",
    classification: "应急避险",
    fabulous: 3,
    source: "应急管理部",
    date: "2021-07-22 15:37:03",
    introduction: "",
    duration: "08:27",
  },
  {
    id: 3,
    title: "警示片《预防台风事故》",
    src: "http://vskd.bj.bcebos.com//video/2021/7/22/20217221626936867460_85_1472.mp4",
    classification: "应急避险",
    fabulous: 3,
    source: "应急管理部",
    date: "2021-07-22 15:37:04",
    introduction: "",
    duration: "08:42",
  },
  {
    id: 4,
    title: "森林消防员的一分钟",
    src: "http://vskd.bj.bcebos.com//video/2021/7/22/20217221626936781978_85_1591.mp4",
    classification: "应急避险",
    fabulous: 6,
    source: "应急管理部",
    date: "2021-07-22 15:37:09",
    introduction: "",
    duration: "02:06",
  },
  {
    id: 5,
    title: "为应急车辆让行",
    src: "http://vskd.bj.bcebos.com//video/2021/7/22/20217221626936782959_85_1264.mp4",
    classification: "应急避险",
    fabulous: 3,
    source: "应急管理部",
    date: "2021-07-22 15:37:11",
    introduction: "",
    duration: "03:15",
  },
  {
    id: 6,
    title: "化学性皮肤灼伤现场急救方法二",
    src: "http://vskd.bj.bcebos.com//video/2021/7/22/20217221626936785319_85_1661.mp4",
    classification: "应急避险",
    fabulous: 0,
    source: "应急管理部",
    date: "2021-07-22 15:37:13",
    introduction: "",
    duration: "01:11",
  },
  {
    id: 7,
    title: "幸福栏目：诚实的好处",
    src: "http://vskd.bj.bcebos.com//video/2019/1/29/20191291548745735699_39_126.mp4",
    classification: "科学百科",
    fabulous: 34,
    source: "幸福栏目-幸福栏目",
    date: "2019-01-30 09:16:32",
    introduction:
      "人们倾向于为了制造一个在他人眼中好的印象而去撒谎然而这其实也会影响到撒谎的人对自己保持诚实是对于建立自己的尊重性以及影响自尊非常重要的。 讲师：泰勒·本·沙哈尔（TalBen-Shahar），哈佛大学心理学硕士、哲学和组织行为学博士，近年专事个人和组织机构的优势开发、自信心，以及领袖力的提升研究。其开设的“积极心理学”和“领袖心理学”被哈佛学生推选为最受欢迎率排名第一和第三的课程。 视频来自：http://www.happier.tv/ 审核人：北京交通大学副教授林思雨",
    duration: "04:53",
  },

  {
    id: 8,
    title: "幸福栏目：去冒险",
    src: "http://vskd.bj.bcebos.com//video/2019/1/29/20191291548745735051_39_1866.mp4",
    classification: "科学百科",
    fabulous: 167,
    source: "幸福栏目-幸福栏目",
    date: "2019-01-30 09:16:32",
    introduction:
      "历史上最成功的科学家和艺术家都是那些在他们成名之前经历过很多次失败的人失败大体上是无法避免并且是痛苦的然而那些从失败当中站起来的人被历史铭记住了勇气并不是说不害怕而是说就算是害怕也要冒着危险去做。 讲师：泰勒·本·沙哈尔（TalBen-Shahar），哈佛大学心理学硕士、哲学和组织行为学博士，近年专事个人和组织机构的优势开发、自信心，以及领袖力的提升研究。其开设的“积极心理学”和“领袖心理学”被哈佛学生推选为最受欢迎率排名第一和第三的课程。 视频来自：http://www.happier.tv/ 审核人：北京交通大学副教授林思雨",
    duration: "04:53",
  },

  {
    id: 9,
    title: "幸福栏目：学会说“不”",
    src: "http://vskd.bj.bcebos.com//video/2018/4/2/2018421522638624808_39_1201.mp4",
    classification: "科学百科",
    fabulous: 4,
    source: "幸福栏目-幸福栏目",
    date: "2018-04-04 11:21:24",
    introduction:
      "简化！尽管善良并对人们说“是”是重要的，但学习何时以及如何说“不”也同样重要。这对清理你生活中不需要的东西是至关重要的。 讲师：泰勒·本·沙哈尔（TalBen-Shahar），哈佛大学心理学硕士、哲学和组织行为学博士，近年专事个人和组织机构的优势开发、自信心，以及领袖力的提升研究。其开设的“积极心理学”和“领袖心理学”被哈佛学生推选为最受欢迎率排名第一和第三的课程。 视频来自：http://www.happier.tv/ 审核人：北京交通大学副教授林思雨",
    duration: "02:02",
  },

  {
    id: 10,
    title: "幸福栏目：美满婚姻的终极贴士",
    src: "http://vskd.bj.bcebos.com//video/2018/4/16/20184161523840832564_39_185.mp4",
    classification: "科学百科",
    fabulous: 4,
    source: "幸福栏目-幸福栏目",
    date: "2018-04-16 09:36:53",
    introduction:
      "重构问题，特别是重构伴侣关系上的问题是一个成功的伴侣关系的关键。为何很多伴侣关系都以失败告终？我们如何保持爱情长久？泰勒通过积极心理学这面镜子回答了这些大问题。 审核人：北京交通大学副教授林思雨",
    duration: "05:32",
  },

  {
    id: 11,
    title: "幸福栏目：如何达到理想生活",
    src: "http://vskd.bj.bcebos.com//video/2018/4/2/2018421522638625269_39_1743.mp4",
    classification: "科学百科",
    fabulous: 5,
    source: "幸福栏目-幸福栏目",
    date: "2018-04-04 11:21:24",
    introduction:
      "泰勒谈到最佳的生活应专注于导致理想生活的各个方面。从而确定使你过上理想生活的重要实施技术是什么。 讲师：泰勒·本·沙哈尔（TalBen-Shahar），哈佛大学心理学硕士、哲学和组织行为学博士，近年专事个人和组织机构的优势开发、自信心，以及领袖力的提升研究。其开设的“积极心理学”和“领袖心理学”被哈佛学生推选为最受欢迎率排名第一和第三的课程。 视频来自：http://www.happier.tv/ 审核人：北京交通大学副教授林思雨",
    duration: "11:01",
  },
  {
    id: 12,
    title: "幸福栏目：欣赏音乐的作用",
    src: "http://vskd.bj.bcebos.com//video/2018/4/2/2018421522638626214_39_1673.mp4",
    classification: "科学百科",
    introduction:
      "音乐欣赏是一种与自己接触和感动自己的好方式。音乐是激发情感的最佳方式之一，它能促进人的幸福生活。 讲师：泰勒·本·沙哈尔（TalBen-Shahar），哈佛大学心理学硕士、哲学和组织行为学博士，近年专事个人和组织机构的优势开发、自信心，以及领袖力的提升研究。其开设的“积极心理学”和“领袖心理学”被哈佛学生推选为最受欢迎率排名第一和第三的课程。 视频来自：http://www.happier.tv/ 审核人：北京交通大学副教授林思雨",
    fabulous: 4,
    source: "幸福栏目-幸福栏目",
    date: "2018-04-04 11:21:23",
    duration: "08:41",
  },
  {
    id: 13,
    title: "警示片《冒顶片帮事故》",
    src: "http://vskd.bj.bcebos.com//video/2021/7/22/20217221626936866510_85_1890.mp4",
    classification: "应急避险",
    fabulous: 2,
    source: "应急管理部",
    date: "2021-07-22 15:37:02",
    introduction: "2021-07-22 15:37:02",
    duration: "08:25",
  },
  {
    id: 14,
    title: "汛期安全小贴士",
    src: "http://vskd.bj.bcebos.com//video/2021/9/10/20219101631243582995_91_1406.mp4",
    classification: "应急避险",
    fabulous: 0,
    source: "应急管理部",
    date: "2021-09-10 12:07:03",
    introduction:
      "车辆行人在暴雨来临时，要选择地势较高处躲避。立交桥洞等地势低洼处容易蓄水造成危险。 如果路面积水，切勿贸然涉水通过。积水过深会使汽车熄火，而井盖被雨水冲起后行人很难察觉。 不可攀爬电线杆、铁塔，也不要到土坯房的屋顶躲避。为什么呢？ 汛期来临，注意安全。",
    duration: "01:00",
  },
  {
    id: 15,
    title: "河道安全篇",
    src: "http://vskd.bj.bcebos.com//video/2021/7/22/20217221626936842451_85_1753.mp4",
    classification: "应急避险",
    fabulous: 0,
    source: "应急管理部",
    date: "2021-07-22 15:36:54",
    introduction: "",
    duration: "01:22",
  },
  {
    id: 16,
    title: "不可小觑的镁元素",
    src: "http://vskd.bj.bcebos.com//video/2021/9/7/2021971630983647186_91_1812.mp4",
    classification: "科学百科",
    fabulous: 0,
    source: "新华网-科学原理一点通",
    date: "2021-09-07 11:55:38",
    introduction:
      "蓝奇奇探索记——不可小觑的镁元素 镁的外表很一般，与其他金属差不多，银白色，而且由于在空气中容易形成一层很薄的氧化膜，所以必须用砂纸打磨以后，才能看到银白色具有金属光泽的外观。与钠元素一样，镁元素也比较活泼，在自然界里总是以化合物的形式存在，由于非常不容易从化合物中还原成单质状态，也是在电池发明之后才通过电解的方法分离出金属镁的。在空气中燃烧的时候，镁会发出耀眼白光，在早期摄影中被用来补充光源，现在的闪光灯泡里仍含有镁元素。不仅如此，镁的耀眼白光还被用于制作烟火和照明弹。镁元素属于人体营养素，是矿物质元素中的一种，含量在人体中仅次于钙、钠、钾，位居第四。",
    duration: "03:00",
  },
  {
    id: 17,
    title: "森林固碳的奥秘",
    src: "http://vskd.bj.bcebos.com//video/2021/9/7/2021971630983661258_91_1358.mp4",
    classification: "科学百科",
    fabulous: 1,
    source: "新华网-科学原理一点通",
    date: "2021-09-07 11:55:38",
    introduction:
      "蓝奇奇探索记——森林固碳的奥秘 很长一段时间，地球上的碳基本保持着“边增长，边消耗”的动态平衡。但是进入工业时代后，人类开始大量开发使用化石燃料，将地球存储下来的碳元素转化为二氧化碳释放到空气中，打破了“碳平衡”，结果导致全球变暖越发严重。减少向大气排放二氧化碳的数量，并且将多余的碳封存固定起来，不排放到大气中才能重新实现“碳平衡”。目前的固碳方式主要有物理固碳和生物固碳。物理固碳是指将二氧化碳长期存储在开采过的深海、油气井和煤层里，而生物固碳则是利用植物的光合作用，将二氧化碳转化为碳水化合物，以有机碳的形式固定在植物体内和土壤中。生物固碳被认为是缓解全球变暖最具前景的方法，其中陆地生态系统在过去几十年一直扮演着重要的角色。",
    duration: "03:00",
  },
  {
    id: 18,
    title: "金蝉脱壳",
    src: "http://vskd.bj.bcebos.com//video/2021/9/7/2021971630983663444_91_1708.mp4",
    classification: "科学百科",
    fabulous: 0,
    source: "新华网-科学原理一点通",
    date: "2021-09-07 11:55:36",
    introduction:
      "蓝奇奇探索记——金蝉脱壳 “金蝉脱壳”是蝉类昆虫在其生命进程中发生的一种生物现象，也就是人们在树林中能经常见到的：蝉从本体脱壳而去，却将蝉衣留在枝头，也就是我们常说的蜕皮，蝉衣也称为蝉蜕。由于蝉身体表面有一层比较坚硬的皮，使体内物质不外流又能防止外界有害之物的入侵，但非常不利于蝉幼虫的生长，它限制了幼蝉身体的长大。因此，蝉类昆虫为了成长，要经常蜕皮。蝉蜕具有很多药理作用，比如止咳平喘、抗过敏、治过敏性鼻炎等等，除了以上几种作用，研究人员还发现蝉壳可以治疗因蚊虫叮咬所导致的皮肤红肿瘙痒，或者由于其他原因所引起的血管神经性水肿、荨麻疹等。蝉蜕还可以通过改善血瘀的情况，来达到缓解支气管痉挛的效果。",
    duration: "03:00",
  },
  {
    id: 19,
    title: "我是科学家-朱廷劭",
    src: "http://vskd.bj.bcebos.com//video/2019/12/18/201912181576651126926_76_1115.mp4",
    classification: "科学百科",
    fabulous: 5,
    source: "果壳-我是科学家",
    date: "2019-12-18 15:43:36",
    introduction:
      "当我们享受着现代生活便利与美好的同时，还有一些人群，正在默默承受生活的茫然、无助甚至绝望。中国科学院心理研究所研究员朱廷劭老师所做的事情，就是默默蹲守着一个树洞，识别出有自杀倾向的人，然后对他们说：且留一步。朱廷劭老师带来分享《如何用人工智能技术，让站在悬崖边缘的人“且留一步”？》。",
    duration: "02:50",
  },

  {
    id: 20,
    title: "我是科学家-赵公博（演讲）",
    src: "http://vskd.bj.bcebos.com//video/2019/12/18/201912181576651140821_76_1213.mp4",
    classification: "科学百科",
    fabulous: 3,
    source: "果壳-我是科学家",
    date: "2019-12-18 15:43:36",
    introduction:
      "我们感知到的整个宇宙，要追溯到138亿年前的宇宙大爆炸。在此之前，宇宙是一个无限小的奇点——宇宙大爆炸之后，我们才有了时间和空间。那么，在大爆炸之后，宇宙又经历了哪些大的变化呢？我们是怎么知道宇宙是正在加速膨胀的？国家天文台研究员赵公博和大家分享《什么样的能量，让宇宙加速膨胀了60亿年？》",
    duration: "19:08",
  },

  {
    id: 21,
    title: "我是科学家-杨益民（演讲）",
    src: "http://vskd.bj.bcebos.com//video/2019/12/18/201912181576651127527_76_1681.mp4",
    classification: "科学百科",
    fabulous: 2,
    source: "果壳-我是科学家",
    date: "2019-12-18 15:43:36",
    introduction:
      "考古是一门需要“穿越”到过去的学科，而科技考古更是能从千百年前保存下来的微小分子（如DNA、蛋白质）中提取到古代先民生活的关键线索。那么，古人的生活习惯究竟是什么样的？他们如何利用自然界中的资源制作化妆棒、面包和乳酪？今天的科学家又如何获得这些信息，来还原古人的日常？中国科学院大学人文学院考古学与人类学系教授杨益民带来分享《古人如何化妆、做奶酪和面包？》。",
    duration: "19:08",
  },

  {
    id: 22,
    title: "我是科学家-邬晓钧",
    src: "http://vskd.bj.bcebos.com//video/2019/12/18/201912181576651141367_76_1444.mp4",
    classification: "科学百科",
    fabulous: 2,
    source: "果壳-我是科学家",
    date: "2019-12-18 15:43:36",
    introduction:
      "声音，无影无形，却是我们沟通交流和感知世界的重要途径。来自清华大学计算机科学与技术系的邬晓钧老师，主要从事的研究就是人类的语言和语音。他的工作，就是从不同人的声音中分辨出他的身份。",
    duration: "03:29",
  },

  {
    id: 23,
    title: "我是科学家-王传超（演讲）",
    src: "http://vskd.bj.bcebos.com//video/2019/12/18/201912181576651128863_76_1387.mp4",
    classification: "科学百科",
    fabulous: 4,
    source: "果壳-我是科学家",
    date: "2019-12-18 15:43:36",
    introduction:
      "一块几百年前、几千年前甚至几十万年前的骨头，会告诉我们什么？几万年前的古人类跟我们的关系是什么？通过骨头中的DNA，我们能够回到过去，把“过去”直接拿来跟“现在”进行比较，从而知道我们是谁，我们从哪里来？厦门大学人类学研究所所长、教授、博士生导师王传超将和大家分享《让DNA来回答：我们的祖先是谁？从哪里来，又要到哪里去？》",
    duration: "22:33",
  },

  {
    id: 24,
    title: "我是科学家-乔友林",
    src: "http://vskd.bj.bcebos.com//video/2019/12/18/201912181576651124711_76_1505.mp4",
    classification: "科学百科",
    fabulous: 6,
    source: "果壳-我是科学家",
    date: "2019-12-18 15:43:36",
    introduction:
      "“我进入公共卫生预防医学领域，已经40多年了。”午后的老科研楼里，中国医学科学院肿瘤研究所研究员乔友林教授静静回顾。“我目前主要从事癌症的流行病学与防治研究工作。之前曾经从事过云南个旧锡矿的矿工肺癌的病因学研究，以及我们国家河南省林县与河北省磁县食管癌的病因及防治研究。现在主要的精力是在进行和妇女有关的两个癌症——宫颈癌跟乳腺癌的防治研究。”",
    duration: "04:00",
  },

  {
    id: 25,
    title: "我是科学家-毛利华",
    src: "http://vskd.bj.bcebos.com//video/2019/12/18/201912181576651128225_76_164.mp4",
    classification: "科学百科",
    fabulous: 3,
    source: "果壳-我是科学家",
    date: "2019-12-18 15:43:36",
    introduction:
      "社交媒体的热搜上，“见义勇为”的故事总是让人又感动又悲伤。新闻背后的评论里，有人赞赏，有人说“傻，不值”，有人说“没数，不懂量力而行”。但北京大学心理与认知科学学院副教授毛利华会关注和思考的是：人为什么要做这样的见义勇为或利他的事情？这样做，会带来什么好处？",
    duration: "02:48",
  },
];
</script>
<style lang="scss" scoped>
ul,
ol {
  list-style: none outside none;
}

ul,
ol,
li,
dl,
dt,
dd {
  padding: 0;
  margin: 0;
}

.video_channel {
  height: 120px;
  margin-bottom: 40px;
  background: #fff;
  box-shadow: 0 4px 20px 0 rgba(74, 118, 227, 0.23);

  .vc_concent {
    display: flex;
    flex-wrap: wrap;
    padding: 24px 0 0;
    @include wrap;

    .vc_item {
      position: relative;
      width: 220px;
      margin-bottom: 10px;
      font-size: 22px;
      font-weight: 600;
      line-height: 30px;
      color: #353535;
      a {
        font-family: PingFangSC-Semibold, sans-serif;
        color: #353535;
        text-decoration: none;
      }
      a:hover {
        color: #1f91f4;
      }
    }

    .vc_item:nth-child(1)::before,
    .vc_item:nth-child(2)::before,
    .vc_item:nth-child(3)::before,
    .vc_item:nth-child(4)::before,
    .vc_item:nth-child(5)::before {
      @include channelSize;
    }

    .vc_item:nth-child(6n + 6) {
      width: 100px;
    }
  }
}

.video_details {
  position: relative;
  @include wrap;
  //video {
  //  margin-bottom: 50px;
  //  vertical-align: middle;
  //}

  .v_player {
    width: 906px;
    height: 510px;
    margin-bottom: 50px;
    vertical-align: middle;

    ::v-deep .vjs-album-control {
      order: 10;
      width: 42px;
      background: url("~@/assets/xuanji.png") no-repeat center;
    }
  }

  .video_album {
    position: absolute;
    top: 0;
    right: 294px;
    width: 200px;
    height: 510px;
    background: #000;
    opacity: 0.6;
    //ul{
    .album_bar {
      display: inline-block;
      width: 200px;
      height: 28px;
      margin-top: 18px;
      font-size: 14px;
      color: #fff;

      .album_item {
        float: left;
        margin-left: 18px;
      }

      .cancel {
        float: right;
        margin-right: 18px;
      }

      .cancel:hover {
        color: #7082f3;
      }

      //border: 2px solid red;
    }

    .album_num {
      width: 200px;
      height: 422px;
      margin-top: 10px;
      overflow: auto;

      * {
        padding: 0;
        margin: 0;
        list-style: none;
      }

      li {
        float: left;
        width: 32px;
        height: 32px;
        margin-bottom: 10px;
        margin-left: 12px;

        p {
          //display: inline-block;
          width: 28px;
          height: 14px;
          padding: 9px 2px;
          font-size: 14px;
          color: #fff;
          text-align: center;
          text-decoration: none;
        }

        //border: 2px solid red;
      }

      .active {
        background-color: #619aff;
      }

      li:nth-child(4n + 1) {
        margin-left: 18px;
      }

      li:hover {
        background: #7082f3;
      }
    }

    //.album_num::-webkit-scrollbar {
    //  width: 0 !important;
    //  -ms-overflow-style: none;
    //  overflow: -moz-scrollbars-none;
    //}

    //}
  }

  //.album_active{
  //
  //}

  .vd_right {
    position: absolute;
    top: 0;
    right: 0;
    width: 276px;
    height: 510px;

    .vd_header {
      margin-bottom: 30px;
      @include clearfix;

      .vdh_author {
        position: relative;
        float: left;
        width: 70px;
        height: 70px;
        overflow: hidden;
        border-radius: 50%;

        img {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: auto;
          transform: translate(-50%, -50%);
        }
      }

      .vdh_title {
        float: left;
        width: 196px;
        margin-left: 10px;

        p {
          margin: 0 0 10px;
          font-size: 18px;
          font-weight: bold;
          color: #333;
        }

        button {
          width: 50px;
          height: 24px;
          padding: 0;
          font-size: 14px;
          color: #fff;
          background: #1f91f4;
          border: none;
          border-radius: 4px;
        }
      }
    }

    .vd_title {
      width: 100%;
      margin-bottom: 10px;

      p {
        font-size: 18px;
        font-weight: 600;
        color: #333;

        button {
          display: inline-block;
          width: 40px;
          height: 18px;
          font-size: 12px;
          color: #fff;
          background: #5381e8;
          border: none;
          border-radius: 4px;
        }
      }
    }

    .vd_text {
      width: 256px;
      height: 180px;
      padding: 10px;
      margin-bottom: 20px;
      overflow-x: hidden;
      overflow-y: auto;
      font-size: 14px;
      color: #666;

      img {
        width: 100%;
        height: auto;
      }
    }

    /* 滚动条 */
    .vd_text::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    .vd_text::-webkit-scrollbar-thumb {
      background-color: #cbcbcb;
      border-radius: 3px;
    }

    .vd_text::-webkit-scrollbar-track {
      background-color: rgba(255, 255, 255, 0.1);
      border-radius: 3px;
    }

    .vd_play_comments {
      @include clearfix;
      @include fontSize(14px, 400, #999, 18px);

      .vdc_play {
        float: left;
      }

      .vdc_comments {
        float: right;
      }
    }

    .vd_release {
      margin: 12px 0;
      @include fontSize(14px, 400, #999, 18px);
    }

    .vd_copyright {
      @include fontSize(14px, 400, #999, 18px);
    }

    .share_info {
      margin-top: 8px;

      .share_sub {
        float: left;
        height: 26px;
        margin-top: 4px;
        vertical-align: middle;
        @include fontSize(14px, 400, #999, 18px);
      }

      ::v-deep .social-share-icon {
        width: 16px;
        height: 16px;
        font-size: 10px;
        line-height: 16px;
      }
    }
  }

  .recommend {
    .title {
      margin: 0 0 16px;
      @include fontSize(24px, bold, #333, 30px);
    }

    .content {
      @include clearfix;

      li {
        float: left;
        width: 270px;
        height: 220px;
        margin-right: 40px;

        a {
          text-decoration: none;
        }

        .cul_img {
          //position: relative;
          width: 270px;
          height: 151px;
          overflow: hidden;
          background-color: #d8d8d8;
          border-radius: 4px;

          img {
            width: 100%;
            //position: absolute;
            //top: 50%;
            //left: 50%;
            //z-index: 3;
            height: 100%;
            //transform: translate(-50%, -50%);
          }

          .time {
            width: 100%;
            height: 18px;
            //position: absolute;
            //bottom: 0;
            //left: 0;
            //z-index: 10;
            //box-sizing: border-box;
            margin-top: -20px;
            //padding: 10px 12px;
            font-size: 14px;
            font-weight: 500;
            line-height: 12px;
            color: #fff;
            //color: red;

            span {
              display: inline-block;
              width: 40%;
              height: 100%;
            }

            span:nth-child(1) {
              margin-left: 5%;
              text-align: left;
            }

            span:nth-child(2) {
              margin-left: 10%;
              text-align: right;
            }
          }
        }

        .cul_title1 {
          margin: 10px 0;
          @include fontSize(16px, 500, #333);
          @include textoverflow;
        }

        .cul_title2 {
          @include fontSize(14px, 400, #999);
        }
      }
    }
  }

  .vd_cmt {
    margin: 20px 0 60px;

    .comment {
      .title {
        position: relative;
        padding-left: 18px;
        @include fontSize(24px, 500, #333);
      }

      .title::after {
        position: absolute;
        top: 6px;
        left: 0;
        display: block;
        width: 6px;
        height: 22px;
        content: "";
        background-color: #0064c9;
      }

      .item {
        margin: 15px 0 30px;

        .item_label {
          @include clearfix;

          .portrait {
            position: relative;
            float: left;
            width: 42px;
            height: 42px;

            .p_img {
              width: 100%;
              height: 100%;
              overflow: hidden;
              border-radius: 50%;

              img {
                width: 100%;
                height: auto;
                vertical-align: middle;
              }
            }

            .p_img::after {
              position: absolute;
              right: 0;
              bottom: 0;
              display: block;
              width: 20px;
              height: 20px;
              line-height: 20px;
              color: #fff;
              text-align: center;
              content: "证";
              background-color: #fd7b43;
              border-radius: 50%;
            }
          }

          .commentator {
            float: left;
            margin-left: 16px;
            @include fontSize(18px, 500, #333, 42px);
          }

          .grade {
            position: relative;
            float: left;
            margin-left: 20px;
            @include fontSize(18px, 500, #fd7b43, 42px);
          }

          .grade::before {
            position: absolute;
            top: 19px;
            left: -10px;
            display: inline-block;
            width: 4px;
            height: 4px;
            margin-right: 4px;
            content: "";
            background-color: #fd7b43;
            border-radius: 50%;
          }
        }

        .item_text {
          margin-left: 58px;
          @include fontSize(16px, 400, #333, 22px);
        }

        .item_date {
          margin: 15px 0 0 58px;
          @include fontSize(14px, 400, #999, 20px);
        }
      }
    }

    .act_footer {
      box-sizing: border-box;
      width: 100%;
      height: 46px;
      padding-left: 20px;
      margin-top: 40px;
      line-height: 46px;
      text-align: center;
      background: #f4f4f4;
      border-radius: 23px;
      @include clearfix;

      button {
        height: 24px;
        padding: 0 8px;
        margin: 0 2px;
        color: #fff;
        background: linear-gradient(180deg, #ee275f 0%, #fc7544 100%);
        background-color: #2491ea;
        background-image: -moz-linear-gradient(
          180deg,
          #65b5fc 0%,
          #2491ea 100%
        );
        background-image: -o-linear-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        background-image: -webkit-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        background-image: -webkit-linear-gradient(
          180deg,
          #65b5fc 0%,
          #2491ea 100%
        );
        background-image: -ms-linear-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        background-image: linear-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        border: none;
        border-radius: 14px;
        outline: none;
      }
    }
  }
}
</style>
